const colors = {
    pink: "#eb69c0",
    ciano: "#28b7fc",
    blue: "#5d6ffb",
    green: "#05ffa1",
    purple: "#a075fc",
    yellow: "#fffb96",
    orange: "#ff901f",
    darkPurple: "#150526"
}

export default colors